// Generated file : do not modify
import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Apprenti
export default class Apprenti  {
  // Identifiant unique
  public id: number;
  // Civilité
  public civiliteId: number;
  // Nom
  public nom: string;
  // Prenom
  public prenom: string;
  // Date de début
  public dateDebut: Date;
  // Date de fin
  public dateFin: Date;
  // Date de rupture
  public dateRupture: Date | null;
  // Id etablissement
  public etablissementId: number;
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Client
  public clientId: number;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.civiliteId = 0;
    this.nom = '';
    this.prenom = '';
    this.dateDebut = new Date(1901,1,1,0,0,0,0);
    this.dateFin = new Date(1901,1,1,0,0,0,0);
    this.dateRupture = null;
    this.etablissementId = 0;
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.clientId = 0;
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: Apprenti): Apprenti {
    const newApprenti: Apprenti = new Apprenti();
    newApprenti.id = obj.id;
    newApprenti.civiliteId = obj.civiliteId;
    newApprenti.nom = obj.nom;
    newApprenti.prenom = obj.prenom;
    newApprenti.dateDebut = new Date(obj.dateDebut);
    newApprenti.dateFin = new Date(obj.dateFin);
    newApprenti.dateRupture = obj.dateRupture ? new Date(obj.dateRupture) : null;
    newApprenti.etablissementId = obj.etablissementId;
    newApprenti.createId = obj.createId;
    newApprenti.failed = obj.failed;
    newApprenti.canUpdate = obj.canUpdate;
    newApprenti.canDelete = obj.canDelete;
    newApprenti.display = obj.display;
    newApprenti.clientId = obj.clientId;
    newApprenti.notifDefType = obj.notifDefType;
    return newApprenti;
  }

  public toJsonApprenti (): string {
    const json = {
      civiliteId: this.civiliteId,
      nom: this.nom,
      prenom: this.prenom,
      dateDebut: this.dateDebut ? new Date (this.dateDebut).toString() : this.dateDebut,
      dateFin: this.dateFin ? new Date (this.dateFin).toString() : this.dateFin,
      dateRupture: this.dateRupture ? new Date (this.dateRupture).toString() : this.dateRupture,
      etablissementId: this.etablissementId,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromApprenti (obj: Apprenti): void {
    this.id = obj.id;
    this.civiliteId = obj.civiliteId;
    this.nom = obj.nom;
    this.prenom = obj.prenom;
    this.dateDebut = new Date(obj.dateDebut);
    this.dateFin = new Date(obj.dateFin);
    this.dateRupture = obj.dateRupture;
    this.etablissementId = obj.etablissementId;
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.clientId = obj.clientId;
    this.notifDefType = obj.notifDefType;
  }

  public compareApprenti (value: Apprenti): boolean {
    return (this.toJsonApprenti() == value.toJsonApprenti());
  }

  public cloneApprenti (): Apprenti {
    return Apprenti.fromJson(this);
  }

  public createForStoreApprenti (): Promise<Apprenti> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/apprentis/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromApprenti(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public updateForStoreApprenti (): Promise<Apprenti> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/apprentis/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromApprenti(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public deleteForStoreApprenti (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/apprentis/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/apprentis/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getForStore (id: number): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Apprentis/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              listData.reccords[0] = Apprenti.fromJson(listData.reccords[0] as Apprenti);
              resolve(listData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<Apprenti> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Apprentis/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = Apprenti.fromJson(listData.reccords[0] as Apprenti);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getDate(apprentis: Apprenti[]) {
    apprentis.forEach((item) => {
      item.dateDebut = item.dateDebut ? new Date(item.dateDebut) : item.dateDebut;
      item.dateFin = item.dateFin ? new Date(item.dateFin) : item.dateFin;
      item.dateRupture = item.dateRupture ? new Date(item.dateRupture) : item.dateRupture;
    })
  }
}
